enum NeuronReportRequest {
  Report = 'NEURON_REPORT',
}

export default NeuronReportRequest;
